// extracted by mini-css-extract-plugin
export default {"productCategoryImg":"ProductCategoryImg_productCategoryImg__lGaCv"};